import renderSections from 'components/sections';
import styles from './faqCategoryContent.module.scss';

const FaqCategoryContent = ({ data, locale }) => {
  if (!data) return null;

  const { title, name, sections } = data;

  return (
    <div className={styles.category}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {renderSections(name, locale, sections, undefined, { hubUrlSlug: data.hub?.urlSlug })}
    </div>
  );
};

export default FaqCategoryContent;
